import React from 'react';
import { Link } from 'react-router-dom';

const ServiceItem = ({ item, category }) => {
  const itemSlug = typeof item === 'string' 
    ? item.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '')
    : '';

  return (
    <Link 
      to={`/gallery?category=${category}&item=${itemSlug}`}
      className="bg-white rounded-lg shadow-sm hover:shadow-md overflow-hidden transition-all duration-300 group p-4 flex items-center space-x-3"
    >
      <div className="w-8 h-8 bg-aqua-50 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-gold-50 transition-colors">
        <svg className="w-4 h-4 text-aqua-600 group-hover:text-gold-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <div className="flex-grow">
        <h3 className="text-base font-medium text-gray-800 group-hover:text-gold-500 transition-colors">
          {item}
        </h3>
      </div>
      <svg className="w-4 h-4 text-gray-400 group-hover:text-gold-500 transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
      </svg>
    </Link>
  );
};

export default ServiceItem;